import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import Order from '@/ts/Order';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'UnpaidPayments', namespaced: true})
export default class UnpaidPayments extends VuexModule {
    public unpaidPaymentsData: Order[] = [];

    get unpaidPaymentData() {
        return this.unpaidPaymentsData;
    }

    @Mutation
    public SET_UNPAID_PAYMENTS_DATA(unpaidPaymentsData: any[]): void {
        this.unpaidPaymentsData = [];
        for (const unpaidPayment of unpaidPaymentsData) {
            this.unpaidPaymentsData.push(new Order(
                unpaidPayment.id,
                unpaidPayment.unit_id,
                unpaidPayment.address,
                unpaidPayment.date,
                unpaidPayment.amount,
                unpaidPayment.vat_amount,
                unpaidPayment.total_amount,
                unpaidPayment.project,
                unpaidPayment.unit,
                unpaidPayment.days_overdue,
                unpaidPayment.description,
                unpaidPayment.tenant_type,
                unpaidPayment.payment_date ? unpaidPayment.payment_date : null,
                unpaidPayment.type,
                unpaidPayment.status,
                unpaidPayment.isAutopaid,
                unpaidPayment.completedRefundsAmount,
                unpaidPayment.pendingRefundsAmount,
                unpaidPayment.remainingAmount,
            ));
        }
    }

    @Action
    public FETCH_UNPAID_PAYMENTS_DATA(): void {
        axios.get(Endpoints.Admin.Finances.FETCH_UNPAID_PAYMENTS_DATA)
            .then((response: any) => {
                store.commit(Mutations.SET_UNPAID_PAYMENTS_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

}
